import { Link } from "react-router-dom";
import BracketPlayOffDetailCard from "components/BracketPlayOffDetailCard";
import { Tournament } from "core/models/Tournament";
import { Bracket } from "core/models/Bracket";
import { Button } from "rsuite";
import clsx from "clsx";

interface PlayoffDetailsProps {
  tournament: Tournament;
  brackets: Bracket;
  handleOpenTournamentChatDrawer: () => void;
  handleOpenScheduleDrawer: () => void;
  handlePrizeDistributionOpen: () => void;
  handleViewReward: () => void;
  handleProcessOverdueResults?: () => void;
  isProcessingOverdueResults?: boolean;
  tournamentCompleted: boolean;
  rewarded: boolean;
  prizeConfig?: any[];
}

export default function BracketPlayoffDetails({
  tournament,
  brackets,
  handleOpenTournamentChatDrawer,
  handleOpenScheduleDrawer,
  handlePrizeDistributionOpen,
  handleViewReward,
  tournamentCompleted,
  handleProcessOverdueResults,
  isProcessingOverdueResults,
  rewarded,
  prizeConfig,
}: PlayoffDetailsProps) {

  const isRoundRobin = tournament?.bracketType === "Round Robin";

  return (
    <>
      <div className="playoff-result-credential-btn">
        <div className="playoff-grp-title">
          <Link to="/playoff/tournaments" className="nav-back">
            Playoff
          </Link>
          <span> / Detail</span>
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
        {Boolean(prizeConfig?.length && !rewarded) && (
            <Button
              id="add-result-btn"
              appearance="ghost"
              onClick={handlePrizeDistributionOpen}
              size={"sm"}
            >
              Add Reward
            </Button>
          )}
          {Boolean(prizeConfig?.length && tournamentCompleted && rewarded) && (
            <Button
              id="view-reward-btn"
              appearance="ghost"
              onClick={handleViewReward}
              size={"sm"}
            >
              View Reward
            </Button>
          )}
          {!isRoundRobin && handleProcessOverdueResults && (
  <Button
    className={clsx("mods-menu", "subtle-btn")}
    appearance="ghost"
    onClick={handleProcessOverdueResults}
    disabled={isProcessingOverdueResults}
    size="sm"
  >
    Progress Bracket
  </Button>
)}
          <Button
            className={clsx("mods-menu", "subtle-btn")}
            appearance="primary"
            onClick={handleOpenScheduleDrawer}
          >
            Schedule
          </Button>
          <Button
            className={clsx("mods-menu", "subtle-btn")}
            appearance="ghost"
            onClick={handleOpenTournamentChatDrawer}
          >
            Chat
          </Button>
        </div>
      </div>
      <div className="playoff-teams">
        <BracketPlayOffDetailCard tournament={tournament} />
      </div>
    </>
  );
}
